// @flow

import * as React from 'react';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import gql from 'graphql-tag';
import withQueryClient from 'components/hoc/withQueryClientService';
import { withCookies } from 'react-cookie';
import Select from '../../../components/Select';
import withLocaleContext from '../../../components/hoc/withLocaleContext';
import { USER_ID } from '../../../common/constants';

const mutation = gql`
  mutation($defaultLanguage: String!, $record: String!) {
    user(data: { defaultLanguage: $defaultLanguage, record: $record }) {
      user {
        name
        surname
        defaultLanguage
      }
    }
  }
`;

const storeUserLocale = ({ client, id, language }) => {
  const variables = {
    defaultLanguage: language,
    record: id
  };

  client
    .mutate({
      mutation,
      variables
    })
    .then(() => {})
    .catch(e => {
      console.error(e);
    });
};

const LanguageSwitcher = ({
  intl,
  localeContext,
  cookies,
  client,
  changeDB = false,
  short = false,
  refreshPage = false
}) => {
  const { changeLocale } = localeContext;
  const id = cookies.get(USER_ID);

  return (
    <Select
      value={intl.locale}
      onChange={e => {
        changeLocale(e.target.value);
        if (changeDB) {
          storeUserLocale({ client, id, language: e.target.value });
        }
        if (refreshPage) {
          window.location.reload();
        }
      }}>
      <option value="cs">{short ? 'cs' : 'cesky'}</option>
      <option value="de">{short ? 'de' : 'deutsch'}</option>
      <option value="en">{short ? 'en' : 'english'}</option>
      <option value="sk">{short ? 'sk' : 'slovensky'}</option>
    </Select>
  );
};

export default compose(
  injectIntl,
  withCookies,
  withLocaleContext,
  withQueryClient
)(LanguageSwitcher);
